import authService from './authService';
import { readData } from './apiResponse';
import type { DashboardSummary } from '../types/planning';

class DashboardService {
  private async getApiClient() {
    return authService.getApiClient();
  }

  /** GET /dashboard — resumo do dia do usuário logado */
  async getSummary(): Promise<DashboardSummary> {
    const apiClient = await this.getApiClient();
    const response = await apiClient.get('/dashboard');
    const data = await readData<DashboardSummary>(response, 'Falha ao carregar o painel');
    return {
      ...data,
      due_today_list: data?.due_today_list ?? [],
      overdue_list: data?.overdue_list ?? [],
      no_due_date_list: data?.no_due_date_list ?? [],
      upcoming_list: data?.upcoming_list ?? [],
      boards: data?.boards ?? [],
      expiring_documents: data?.expiring_documents ?? [],
      expiring_count: data?.expiring_count ?? 0,
      upcoming_invoices: data?.upcoming_invoices ?? [],
      budget: data?.budget ? { ...data.budget, items: data.budget.items ?? [] } : null,
      finance: data?.finance
        ? {
            ...data.finance,
            accounts_balance_cents: data.finance.accounts_balance_cents ?? 0,
            projected_balance_cents: data.finance.projected_balance_cents ?? 0,
            month_income_cents: data.finance.month_income_cents ?? 0,
            month_expense_cents: data.finance.month_expense_cents ?? 0,
            month_net_cents: data.finance.month_net_cents ?? 0,
            uncategorized_count: data.finance.uncategorized_count ?? 0,
            accounts: data.finance.accounts ?? [],
          }
        : null,
      scheduling: data?.scheduling
        ? {
            ...data.scheduling,
            to_schedule: data.scheduling.to_schedule ?? [],
            missed: data.scheduling.missed ?? [],
            scheduled_next_30_count: data.scheduling.scheduled_next_30_count ?? 0,
            scheduled_next_30_cents: data.scheduling.scheduled_next_30_cents ?? 0,
            upcoming_next_30_count: data.scheduling.upcoming_next_30_count ?? 0,
          }
        : null,
    };
  }
}

export const dashboardService = new DashboardService();
export default dashboardService;
